import { Link } from "react-router-dom";

import Seo from "../../components/Seo";
import LegalPublicLayout from "../Legal/LegalPublicLayout";

/**
 * Public 404 — unknown URLs must not look like the homepage.
 */
export default function NotFoundPage() {
  return (
    <LegalPublicLayout>
      <Seo
        title="Pagina nu există | AIFoiParcurs"
        description="Pagina cerută nu există pe AIFoiParcurs. Revino la pagina principală pentru foi de parcurs online."
        path="/"
        noIndex
      />
      <main className="legal-doc">
        <div className="legal-doc__inner">
          <Link to="/" className="legal-doc__back">
            ← Înapoi la pagina principală
          </Link>

          <div className="legal-doc__panel">
            <p className="legal-doc__eyebrow">Eroare 404</p>
            <h1 className="legal-doc__title">Pagina nu există</h1>
            <p className="legal-doc__lead">
              Adresa pe care ai deschis-o nu corespunde unei pagini de pe site.
              Nu te-am trimis pe pagina principală ca să nu se amestece cu
              articolele și ghidurile reale.
            </p>
            <p className="legal-doc__p">
              Poți reveni la{" "}
              <Link to="/" className="legal-doc__back">
                pagina principală
              </Link>{" "}
              sau la ghidurile din subsol, la Ghiduri.
            </p>
          </div>
        </div>
      </main>
    </LegalPublicLayout>
  );
}
